import type { TruckComplianceStatus } from '@chukua/common';

/** Tag colour and label for a compliance status — matches the existing Ant status-tag convention (`CustomersTable`'s active/inactive tags). */
export const COMPLIANCE_LABELS: Record<TruckComplianceStatus, { label: string; color: string }> = {
  valid: { label: 'Valid', color: 'success' },
  expiring_soon: { label: 'Expiring soon', color: 'warning' },
  expired: { label: 'Expired', color: 'error' },
  none: { label: 'No documents', color: 'default' },
};
